module.exports = __webpack_public_path__ + "static/img/dianpu.91218c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dianpu.png
// module id = uPxW
// module chunks = 1